<div class="row g-2 g-md-2 mt-2">
  @for (item of menuItems; track item) {
    <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 menubox">
      
      <button type="button"
        class="btn w-100 h-100 bg-white border rounded-3 shadow-sm d-flex flex-column align-items-center justify-content-center text-center menu-tile" 
        style="min-height:150px; line-height: 1.1; --tile-color: {{item.clrCode}}"
        data-bs-toggle="modal" (click)="menuClick(item)"
        [disabled]="item.locked"><i class="bi bi-box formod" *ngIf="item.for_module"></i>
        @if(item.locked) {<i class="bi bi-lock-fill locked"></i>}
        <div class="d-flex align-items-center justify-content-center rounded-circle mb-3 menu-tile-icon" 
          style="width:56px; height:56px; background-color: {{item.clrCode}}1a; color: {{item.clrCode}}">
          <i class="bi fs-3" [ngClass]="item.icon"></i>
        </div>
        @if(item.passcode) {<i class="bi bi-key-fill locked" style="color: lightgreen"></i>}
        <div class="fw-semibold text-dark">{{item.title}}</div>
        <div class="small text-muted mt-1">{{item.desc}}</div>
      </button>

    </div>
  } @empty {
    <div class="d-flex align-items-center justify-content-center flex-column lead text-danger mt-5">
      <i class="bi bi-exclamation-triangle" style="font-size: 48px;"></i>
      <span class="fs-2">Error! Initial setup is not yet done for <u>dashboard menu</u>.</span>
    </div>
  }
</div>
